import './Checkbox.scss';
import clsx from 'clsx';
import React, { ChangeEvent, InputHTMLAttributes, memo, PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
  id: string;
  checked: boolean;
  label?: ReactNode;
  partial?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}>;

export type CheckboxProps = Props & InputHTMLAttributes<HTMLInputElement>;

export const Checkbox = memo((
  {
    onChange,
    disabled,
    value,
    id,
    checked,
    name,
    required,
    label,
    partial,
    ...rest
  }: CheckboxProps,
) => (
  <div className="bp-checkbox">
    <input
      {...rest}
      type="checkbox"
      className={clsx({
        'bp-checkbox__input': true,
        'bp-checkbox__input--partial': partial,
      })}
      onChange={onChange}
      id={id}
      disabled={disabled}
      value={value}
      name={name}
      required={required}
      checked={checked}
    />

    <label
      htmlFor={id}
      className={clsx({
        'bp-checkbox__label': true,
        'bp-checkbox__label--disabled': disabled,
      })}
    >
      <span className={clsx({
        'bp-checkbox__appearance': true,
        'bp-checkbox__appearance--disabled': disabled,
      })}
      />

      {label && (
        <p className={clsx({
          'bp-checkbox__label-text': true,
          'bp-checkbox__label-text--disabled': disabled,
        })}
        >
          {label}
        </p>
      )}
    </label>
  </div>
));
